<template>
  <div class="research_wrap">
    <el-carousel
      height="37vw"
      loop
      arrow="never"
      class="hidden-xs-only"
      indicator-position="none"
    >
      <el-carousel-item v-for="(item, index) in imgList" :key="index">
        <img :src="item.src" alt="" class="img_item" />
        <div class="tips_font">
          <h1>{{ item.line1 }}</h1>
          <h1>{{ item.line2 }}</h1>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div class="production_img hidden-sm-and-up">
      <div class="img_tit">标准化体系建设</div>
      <div class="img_desc">专注氢能产业研究，构建产业研究的数字化系统</div>
    </div>

    <div class="research_card hidden-xs-only">
      <div class="research-left">
        <div class="research-left-title">氢能标准化体系建设</div>
        <div class="research-left-desc">
          建立氢能产业标准化工作体系 ， 加强氢能 安全 、 组织标准宣贯
        </div>
        <div class="research-left-desc">
          重点研究燃料电池 、 电解水装备 、 氢基燃 料 、 氢气储存 、
          运输标准等领域 ， 完善氢 能安全应用标准
        </div>
        <div class="research-left-instrc">工作进展</div>
        <div class="research-left-desc">
          2025年新增申报专利3项，参与制定标准3项
        </div>
      </div>
      <div class="research_card_right">
        <img src="@/assets/img/build.543dd76.png" alt="" />
      </div>
    </div>

    <div class="research_card_mobile hidden-sm-and-up">
      <h1>氢能标准化体系建设</h1>
      <p>建立氢能产业标准化工作体系 ， 加强氢能 安全 、 组织标准宣贯</p>
      <p>
        重点研究燃料电池 、 电解水装备 、 氢基燃 料 、 氢气储存 、
        运输标准等领域 ， 完善氢 能安全应用标准
      </p>
      <h2>工作进展</h2>
      <p>2025年新增申报专利3项，参与制定标准3项</p>
      <img src="@/assets/img/build.543dd76.png" alt="" />
    </div>

    <div class="research_title_wrap">
      <div class="research_inner">
        <div class="inner_left">
          <img src="../../assets/img/tupianright.png" alt="" />
        </div>
        <div class="inner_center">
          <div class="research_title">院标</div>
          <div class="research_desc"></div>
        </div>
        <div class="inner_right">
          <img src="../../assets/img/tupianleft.png" alt="" />
        </div>
      </div>
      <div class="research_inner1">
        <div class="inner">
          <img src="../../assets/biao1.png" alt="" />
          <img src="../../assets/biao2.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imgList: [
        {
          src: require("@/assets/img/yjbg1.550eeb6.png"),
          line1: "标准化体系建设",
          line2: "专注氢能产业研究，构建产业研究的数字化系统",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.research_wrap {
  position: relative;
  width: 100%;
  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/banner22.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .el-carousel__item {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .tips_font {
    position: absolute;
    top: 260px;
    left: 300px;
    z-index: 5;
    color: #2d3937;
    font-size: 25px;
    @media screen and (max-width: 768px) {
      font-size: 0.5rem;
    }
  }
  .research_card {
    width: 72%;
    margin: 0 auto;
    position: relative;
    z-index: 5;
    margin-top: -200px;
    background: #ffffff;
    padding: 40px;
    display: flex;
    background: url("../../assets/img/bg.722080d.png");
    background-size: 100% 100%;
    .research-left {
      .research-left-title {
        font-size: 34px;
        font-weight: bold;
        color: #000;
      }
      .research-left-desc {
        color: #5b6e74;
        line-height: 2rem;
        font-size: 19px;
      }
      .research-left-instrc {
        font-size: 24px;
        margin-top: 20px;
      }
      ul {
        .research-left-detail {
          font-size: 18px;
          margin-top: 12px;
          span {
            font-weight: bold;
            color: #000;
          }
        }
      }
    }
    .research_card_right {
      margin-left: 50px;
      img {
      }
    }
  }
  .research_card_mobile {
    width: 100%;
    padding: 1rem;
    background: url("../../assets/img/bg.722080d.png") 0 0 no-repeat;
    background-size: cover;
    position: relative;
    h1 {
      font-size: 1.3rem;
    }
    p {
      margin-top: 1rem;
      font-size: 0.9rem;
      color: #5b6e74;
      line-height: 1.5rem;
    }
    h2 {
      margin-top: 1rem;
      font-weight: normal;
      font-size: 1rem;
      color: #000;
    }
    img {
      position: absolute;
      right: 1rem;
      width: 30% !important;
      bottom: -4rem;
      opacity: 0.6;
    }
  }
  .research_title_wrap {
    width: 100%;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .research_inner {
      display: flex;
      justify-content: center;
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30% !important;
        }
      }
      .inner_center {
        width: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 2.2;
        }
        .research_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .research_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30% !important;
        }
      }
    }
    .research_inner1 {
      width: 100%;
      display: flex;
      justify-content: center;
      .inner {
        margin-top: 20px;
        width: 70%;
        display: flex;
        justify-content: space-around;
        img {
          width: 30% !important;
          @media screen and (max-width: 768px) {
            width: 45% !important;
          }
        }
      }
    }
  }
  .research_sp_wrap {
    width: 70%;
    margin: 0 auto;
    height: 300px;
    .research_sp_row {
      width: 100%;
      .research_sp_col {
        background-size: 100% 100%;
        height: 420px;
        padding: 200px;
        &:nth-child(1) {
          background: url("../../assets/img/researchInstitute/1.png");
        }
        &:nth-child(2) {
          background: url("../../assets/img/researchInstitute/2.png");
        }
        &:nth-child(3) {
          background: url("../../assets/img/researchInstitute/3.png");
        }
        .tit {
          font-size: 32px;
          color: #000;
          margin: 0 30px;
        }
        .desc {
          font-size: 19px;
          margin: 10px 30px;
        }
      }
    }
  }
  .research_sp_wrap_mobile {
    width: 90%;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .product_shows_wrap {
    width: 100%;
    background: #f4f9fc;
    background-size: cover;
    padding: 10px 0 50px 0;
    box-sizing: border-box;
    margin-top: 250px;
    margin-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .production_title_wrap {
      width: 100%;
      margin-top: 50px;
      @media screen and (max-width: 768px) {
        margin-top: 30px;
      }
      .production_inner {
        display: flex;
        justify-content: center;
        .inner_left {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          @media screen and (max-width: 768px) {
            flex: 1;
          }
          img {
            width: 30%;
          }
        }
        .inner_center {
          width: 400px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0 50px;
          @media screen and (max-width: 768px) {
            flex: 2.2;
          }
          .production_title {
            font-size: 40px;
            font-weight: bold;
            @media screen and (max-width: 768px) {
              font-size: 1rem;
            }
          }
          .production_desc {
            font-size: 16px;
            color: #787878;
            margin-top: 10px;
            @media screen and (max-width: 768px) {
              margin-top: 10px;
            }
          }
        }
        .inner_right {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          @media screen and (max-width: 768px) {
            flex: 1;
          }
          img {
            width: 30%;
          }
        }
      }
    }
    .card_fan_list {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .card_fan_wrap {
        flex-wrap: wrap;
        margin-top: 50px;
      }
      .card_fan_item {
        display: flex;
        align-items: center;
        background: #fff;
        margin-top: 50px;
        padding: 30px;
        box-shadow: 10px 10px 20px rgba($color: #000, $alpha: 0.1);
        @media screen and (max-width: 768px) {
          background: url("../../assets/img/icon2.png") 0 0 no-repeat;
          background-position: 100% 100%;
          background-size: 35%;
          height: 100px;
          &:nth-child(n + 3) {
            margin-top: 25px;
          }
        }
        .card_left {
          width: 20%;
          img {
            width: 100%;
          }
        }
        .card_right {
          margin-left: 15px;
          h1 {
            font-size: 25px;
            @media screen and (max-width: 768px) {
              font-size: 14px;
            }
          }
          p {
            font-size: 18px;
            margin-top: 10px;
            @media screen and (max-width: 768px) {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .develop_wrap {
    width: 70%;
    margin: 0 auto;
    display: flex;
    @media screen and (max-width: 768px) {
      width: 90%;
      flex-direction: column;
      margin-bottom: 30px;
    }
    .develop_left {
      margin-right: 100px;
      h1 {
        font-size: 26px;
        @media screen and (max-width: 768px) {
          font-size: 0.95rem;
        }
      }
      p {
        margin-top: 30px;
        font-size: 20px;
        color: #5b6e74;
        @media screen and (max-width: 768px) {
          font-size: 13px;
        }
      }
    }
    .develop_right {
      width: 100%;
      @media screen and (max-width: 768px) {
        width: 40%;
        margin: 0 auto;
      }
      img {
        width: 100%;
      }
      .tips {
        text-align: center;
        color: #2091d3;
        font-size: 20px;
        cursor: pointer;
      }
    }
  }
}
</style>